import { makeApi } from "@zodios/core";

import { apiKeyApi } from "./open-ai/apiKey.ts";
import { generatedImagesApi } from "./open-ai/generatedImages.ts";
import { questionAnswersApi } from "./open-ai/questionAnswers.ts";
import { refinedContentApi } from "./open-ai/refinedContent.ts";
import { sceneSuggestionsApi } from "./open-ai/sceneSuggestions.ts";

export const openAiApi = makeApi([
  ...apiKeyApi,
  ...generatedImagesApi,
  ...questionAnswersApi,
  ...refinedContentApi,
  ...sceneSuggestionsApi,
]);

export * from "./open-ai/apiKey.ts";
export * from "./open-ai/generatedImages.ts";
export * from "./open-ai/questionAnswers.ts";
export * from "./open-ai/refinedContent.ts";
export * from "./open-ai/sceneSuggestions.ts";
export * from "./response.ts";
